document.addEventListener('DOMContentLoaded', function() {
  // Prevent script from running multiple times if injected dynamically
  if (window.globalTooltipInitialized) return;
  window.globalTooltipInitialized = true;

  function positionTooltip(container) {
    const tooltip = container.querySelector('.global-tooltip-text');
    if (!tooltip) return;
    const rect = container.getBoundingClientRect(); 
    
    let left = rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2);
    if (left < 10) left = 10; 
    else if ((left + tooltip.offsetWidth) > (window.innerWidth - 10)) {
      left = window.innerWidth - tooltip.offsetWidth - 10;
    }

    const top = rect.top - tooltip.offsetHeight - 10;

    tooltip.style.top = top + 'px';
    tooltip.style.left = left + 'px';
  }

  function hideAllTooltips() {
    document.querySelectorAll('.global-tooltip-container.is-visible').forEach(el => {
      el.classList.remove('is-visible');
    });
  }

  const tooltipContainers = document.querySelectorAll('.global-tooltip-container');

  tooltipContainers.forEach(container => {
    
    // --- Desktop Behavior (Hover) ---
    container.addEventListener('mouseenter', function() {
      if (window.innerWidth >= 1024) {
        // 1. Clear ONLY this specific tooltip's timeout
        clearTimeout(this.hideTimeout); 
        
        // 2. Instantly close any other tooltips that might be open
        hideAllTooltips(); 
        
        positionTooltip(this);
        this.classList.add('is-visible');
      }
    });

    container.addEventListener('mouseleave', function() {
      if (window.innerWidth >= 1024) {
        // 3. Attach the timeout to 'this' container, not a global variable
        this.hideTimeout = setTimeout(() => {
          this.classList.remove('is-visible');
        }, 300); 
      }
    });

    // --- Mobile Behavior (Click/Tap) ---
    container.addEventListener('click', function(e) {
      if (window.innerWidth < 1024) {
        if (e.target.tagName.toLowerCase() === 'a') return; 
        
        e.preventDefault();
        e.stopPropagation(); 
        
        // If clicking a new one, close others first
        if (!this.classList.contains('is-visible')) {
           hideAllTooltips();
        }
        
        positionTooltip(this);
        this.classList.toggle('is-visible');
      }
    });
  });

  document.addEventListener('touchstart', function(e) {
    if (!e.target.closest('.global-tooltip-container')) hideAllTooltips();
  }, { passive: true });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.global-tooltip-container')) hideAllTooltips();
  });
});